import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=40af13cf&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40af13cf')) {
      api.createRecord('40af13cf', component.options)
    } else {
      api.reload('40af13cf', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=40af13cf&", function () {
      api.rerender('40af13cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZiPvTylgyOuM/JS/comp/openstreetmap.vue"
export default component.exports